import { ImportModal } from "@/components";
import { getMessageResponseType, handleMessagesAPI } from "@/utils";
import moment from "moment";
import { mapState } from "vuex";
import {
  DATE_FORMAT_HM,
  REQUEST_TYPE_HOUR,
  REQUEST_TYPE_SHIFT,
  Role,
  statusTimesheet,
} from "../../components/commons/commonConstant";
import {
  convertObjectToParams,
  downloadFile,
  formatDateToString,
  getInfoStaff,
  getStatusTimeSheet,
  getUnique,
  initFilters,
  scaleScreen,
} from "../../components/commons/commons";
import FilterLayout from "../../components/layouts/FilterLayout";
import http from "../../store/modules/helpers/httpInterceptor";
import StaffTimesheetDetail from "./StaffTimesheetDetail/StaffTimesheetDetail.vue";
import CommentsTimesheet from "./ViewComments/CommentsTimesheet.vue";
import TimesheetViewHR from "./ViewHR/TimesheetViewHR.vue";
import TimesheetViewUser from "./ViewUser/TimesheetViewUser.vue";

const column = [
  {
    title: "Staff",
    dataIndex: "staff",
    key: "staff",
    scopedSlots: { customRender: "staff" },
  },
];

export default {
  name: "Timesheet",
  components: {
    FilterLayout,
    TimesheetViewHR,
    StaffTimesheetDetail,
    TimesheetViewUser,
    CommentsTimesheet,
    ImportModal,
  },

  data() {
    return {
      column,
      page: "Timesheet",
      currentScreen: "",
      showDrawer: false,
      selectedRowKeys: [],
      loading: false,
      titleDrawer: "",
      drawerKey: undefined,
      dataSource: [],
      configPage: {
        pageSize: 20,
        currentPage: 1,
        totalElement: 0,
        sort: "name",
        direction: "asc",
      },
      formCalculateTimeSheets: this.$form.createForm(this, {
        name: "formCalculateTimeSheets",
        onValuesChange: this.onValuesChange,
      }),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 },
      },
      formCalculateTimeSheetsAll: this.$form.createForm(this, {
        name: "formCalculateTimeSheetsAll",
        onValuesChange: this.onValuesChange,
      }),
      formItemLayoutAll: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 },
      },

      fromDate: null,
      toDate: null,
      formData: {
        calculate_date: moment(this.toDate),
      },

      currentFilterPeriod: null,
      currentFilterEmployee: null,
      dataFilters: {},
      timesheetInfo: {},
      statusTimesheet,
      visibleModal: false,
      visibleConfirm: false,
      visibleCalculateWorkingDay: false,
      visibleCalculateWorkingDayAllEmp: false,
      visibleUpdateJob: false,
      commentReject: "",
      isValidComment: true,
      keyTab: "list",
      role: Role,
      value: 1,
      isExcept: false,
      fetching: false,
      staffListExcept: [],
      haveRowSelect: false,
      firstCreated: true,
      staffSelectedListExcept: [],
      selectOptionData: [],
      tabChange: false,
      formUpdate: this.$form.createForm(this, { name: "updateHistory" }),
      timeout: null,
      requestType: REQUEST_TYPE_SHIFT,

      isShowModalImport: false,
      loadingDownload: false,
    };
  },
  watch: {
    showDrawer: function () {
      this.myFunction();
    },
    staffListExcept: function () {
      this.onChangeValue();
    },
    keyTab: function () {
      this.tabChange = true;
    },
  },
  created() {
    this.scaleScreen();
    this.$store.dispatch("timesheet/getNotes");
    this.currentScreen = "timesheet";
    this.configPage = {
      pageSize: JSON.parse(sessionStorage.getItem(this.page))
        ? JSON.parse(sessionStorage.getItem(this.page)).size
          ? JSON.parse(sessionStorage.getItem(this.page)).size
          : 20
        : 20,
      currentPage: JSON.parse(sessionStorage.getItem(this.page))
        ? JSON.parse(sessionStorage.getItem(this.page)).page
          ? JSON.parse(sessionStorage.getItem(this.page)).page
          : 1
        : 1,
      totalElement: 0,
      sort: JSON.parse(sessionStorage.getItem(this.page))
        ? JSON.parse(sessionStorage.getItem(this.page)).sort
          ? JSON.parse(sessionStorage.getItem(this.page)).sort
          : "name"
        : "name",
      // direction: JSON.parse(sessionStorage.getItem(this.page)).direction ? JSON.parse(sessionStorage.getItem(this.page)).direction : 'asc'
    };
    this.requestType = this.userInfo.requestType;
    this.handFilters();
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      timesheetUser: (state) => (state.timesheet.timesheetUser ? state.timesheet.timesheetUser : {}),
      calculationWorking: (state) => state.timesheet.calculationWorking,
      employeeList: (state) => state.application.employeeList,
      payrollPeriodList: (state) => state.application.payrollPeiodList,
    }),
  },
  props: {
    msg: String,
  },
  mounted() {
    this.keyTab = this.roles.includes(this.role.ADMIN) || this.roles.includes(this.role.HR) 
      || this.roles.includes(this.role.HRM) ? "list" : "detail";
  },
  methods: {
    scaleScreen,
    // ...mapActions(["getTimeSheetDrawerData"]),

    onSetDataFilters: function(filter) {
      if (this.firstCreated || this.tabChange) {
        filter.payroll_period = this.dataFilters.payroll_period
          ? this.dataFilters.payroll_period
          : filter.payroll_period;
      }

      filter.payroll_period = filter.payroll_period ? filter.payroll_period : this.dataFilters.payroll_period;

      this.currentFilterPeriod = filter.payroll_period;
      this.currentFilterEmployee = filter.employee;
    },

    handFilters() {
      const { currentScreen, userInfo, payrollPeriodList } = this;
      initFilters(this.dataFilters, currentScreen, userInfo);
      this.dataFilters = { ...this.dataFilters, ...JSON.parse(sessionStorage.getItem(this.page)) };

      let findCurrentPeriod = payrollPeriodList.find((item) => item.is_current_timesheet);
      this.setDefaultDateFromPeriod(findCurrentPeriod);
    },

    disableDate(current) {
      if (!current) {
        return false;
      }

      // Chuyển đổi fromDate và toDate sang moment
      const fromDateMoment = moment(this.fromDate);
      const toDateMoment = moment(this.toDate);

      const isWeekend = current.isoWeekday() === 6 || current.isoWeekday() === 7; // 6: Thứ 7, 7: Chủ nhật
      const isBeforeFromDate = current.isBefore(fromDateMoment, 'day'); // So sánh theo ngày
      const isAfterToDate = current.isAfter(toDateMoment, 'day'); // So sánh theo ngày
      const isFutureDate = current.isAfter(moment(), 'day');
      // Trả về true nếu là cuối tuần hoặc nằm ngoài khoảng
      return isWeekend || isBeforeFromDate || isAfterToDate || isFutureDate;
    },

    setDefaultDateFromPeriod(period) {
      if (period) {
        this.fromDate = new Date(period.from_date);
        this.toDate = new Date(period.to_date);
        this.formData.calculate_date = moment(this.toDate);
        let calculateDateDefault = this.formData.calculate_date.clone();

        let currentDate = new Date();

        if (this.fromDate > currentDate) {
          return;
        }

        while (this.disableDate(calculateDateDefault)) {
          calculateDateDefault.subtract(1, 'days');
        }

        this.formData.calculate_date = calculateDateDefault;
      }
    },

    handleChangeDate(date) {
      this.formCalculateTimeSheets.setFieldsValue({
        calculate_date: date,
      });
    },

    handleChangeDateAll(date) {
      this.formCalculateTimeSheetsAll.setFieldsValue({
        calculate_date: date,
      });
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    onSearchStaff(value) {
      let cloneVal = decodeURI(value);
      let cloneSelectOptionData = [];
      cloneSelectOptionData = this.selectOptionData;
      if (value && value !== "" && value.length >= 3) {
        this.fetching = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$store
            .dispatch("application/getEmployeeList", cloneVal)
            .then((res) => {
              cloneSelectOptionData = [...cloneSelectOptionData, ...res];
              this.selectOptionData = getUnique(cloneSelectOptionData, "id");
              this.fetching = false;
            })
            .catch(() => {
              this.fetching = false;
            });
        }, 1000);
      }
    },

    onChangeValue(value) {
      let newStaffList = this.selectOptionData.filter((a) => value.includes(a.id));
      this.staffListExcept = newStaffList;
      this.staffSelectedListExcept = value;
    },

    onDelete(key) {
      let cloneStaffListExcept = this.staffListExcept.filter((item) => item.id !== key);
      let staffSelectedListExcept = [];
      staffSelectedListExcept = cloneStaffListExcept.map((item) => {
        return item.id;
      });
      this.staffListExcept = cloneStaffListExcept;
      this.staffSelectedListExcept = staffSelectedListExcept;
    },

    onApplyFilters(filters) {
      this.dataFilters = filters;
      if (!this.firstCreated && !this.tabChange) {
        this.configPage.currentPage = 1;
      }
      this.getTimesheetDetail(filters.payroll_period);
      if (this.keyTab !== "list") {
        this.getUserTimesheetDetail(this.userInfo.userId);
      } else {
        this.getTimesheetData();
      }
      this.tabChange = false;
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      this.haveRowSelect = selectedRowKeys.length > 0 ? true : false;
    },

    exportTimesheet() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("click");
        const {
          departmentsFilter,
          divisions,
          location,
          workScheduleTypes,
          role,
          reason_type,
          payroll_period,
          employee,
          abnormal_case,
        } = this.dataFilters;
        const data = {
          location: location ?? [],
          departmentsFilter: departmentsFilter ?? [],
          role: role ?? [],
          employee: employee ?? [],
          divisions: divisions ?? [],
          workScheduleTypes: workScheduleTypes ?? [],
          reason_type: reason_type ?? [],
          actionAbnormalCase: abnormal_case ? true : false,
          employee_id: this.selectedRowKeys,
        };
        this.$store.dispatch("user/loadingRequest");
        http
          .post(`tms/excel/${payroll_period}/rule`, data, { responseType: "blob" })
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              downloadFile(res.data, `Timesheet_List_T${moment(this.timesheetInfo.to_date).format("MM-yyyy")}.xlsx`);
              this.$message.success("Timesheet is exported successfully!", 5);
            } else {
              this.$message.error("No data export", 5);
            }
          })
          .catch((err) => {
            if (err.response.data.error) {
              this.$message.error(err.response.data.error, 5);
            } else {
              this.$message.error("Server Time Out!", 5);
            }
          })
          .finally(() => {
            this.$store.commit("user/RESET_LOADING");
          });
      }, 500);
    },

    exportTimesheet2() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("click");
        const {
          departmentsFilter,
          divisions,
          location,
          workScheduleTypes,
          role,
          reason_type,
          payroll_period,
          employee,
          abnormal_case,
        } = this.dataFilters;
        const data = {
          location: location ?? [],
          departmentsFilter: departmentsFilter ?? [],
          role: role ?? [],
          employee: employee ?? [],
          divisions: divisions ?? [],
          workScheduleTypes: workScheduleTypes ?? [],
          reason_type: reason_type ?? [],
          actionAbnormalCase: abnormal_case ? true : false,
          employee_id: this.selectedRowKeys,
        };
        this.$store.dispatch("user/loadingRequest");
        http
          .post(`tms/excel/${payroll_period}/rule2`, data, { responseType: "blob" })
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              downloadFile(res.data, `Timesheet_List_T${moment(this.timesheetInfo.to_date).format("MM-yyyy")}.xlsx`);
              this.$message.success("Timesheet is exported successfully!", 5);
            } else {
              this.$message.error("No data export", 5);
            }
          })
          .catch(async (error) => {
            if (error.request.responseType === "blob" && error.response.data instanceof Blob) {
              const errorObject = JSON.parse(await error.response.data.text());
              this.$message.error(errorObject.code, 5);
            }
          })
          .finally(() => {
            this.$store.commit("user/RESET_LOADING");
          });
      }, 500);
    },

    exportTimesheetDetail() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("click");
        if (this.selectedRowKeys.length > 0) {
          const data = {
            employeeId: this.selectedRowKeys,
            timesheetId: this.dataFilters.payroll_period,
          };
          this.$store.dispatch("user/loadingRequest");
          http
            .post("tms/excel/zip", data, { responseType: "blob" })
            .then((res) => {
              if (res.status === 200 && res.data.type !== "application/json") {
                downloadFile(res.data, `Timesheet_Detail_T${moment(this.timesheetInfo.to_date).format("MM-yyyy")}.zip`);
                this.$message.success("Timesheet detail is exported successfully!", 5);
              } else {
                this.$message.error("No data export", 5);
              }
            })
            .catch((err) => {
              if (err.response.data.error) {
                this.$message.error(err.response.data.error);
              } else {
                this.$message.error("Server Time Out!", 5);
              }
            })
            .finally(() => {
              this.$store.commit("user/RESET_LOADING");
            });
        }
      }, 500);
    },

    cancelConfirm() {
      this.visibleConfirm = false;
      this.value = 1;
    },

    cancelCalculateWorkingDay() {
      this.visibleCalculateWorkingDay = false;
      this.handleCancel();
      this.formCalculateTimeSheets.resetFields();
    },

    cancelCalculateWorkingDayAllEmp() {
      this.visibleCalculateWorkingDayAllEmp = false;
      this.handleCancel();
      this.formCalculateTimeSheetsAll.resetFields();
    },

    pressCalculateWorkingDayButton() {
      const { payrollPeriodList } = this;
      // validate work hours for future Timesheet
      let findChangePeriod = payrollPeriodList.find((item) => item.timesheet_id === this.currentFilterPeriod);
      if (findChangePeriod) {
        let fromDate = new Date(findChangePeriod.from_date);
        let currentDate = new Date();
        if (fromDate > currentDate) {
          this.$message.error("Can not calculate work hours for future Timesheet.");
          return;
        }
      }
      // validate list employee
      if(!this.currentFilterEmployee || this.currentFilterEmployee.length === 0) {
        this.$message.error("Please choose at least 1 employee to calculate the timesheet !", 1);
        return;
      }
      this.setDefaultDateFromPeriod(findChangePeriod);
      this.visibleCalculateWorkingDay = true;
    },

    pressCalculateWorkingDayAllEmpButton() {
      const { payrollPeriodList } = this;
      // validate work hours for future Timesheet
      let findChangePeriod = payrollPeriodList.find((item) => item.timesheet_id === this.currentFilterPeriod);
      if (findChangePeriod) {
        let fromDate = new Date(findChangePeriod.from_date);
        let currentDate = new Date();
        if (fromDate > currentDate) {
          this.$message.error("Can not calculate work hours for future Timesheet.");
          return;
        }
      }
      this.setDefaultDateFromPeriod(findChangePeriod);
      this.visibleCalculateWorkingDayAllEmp = true;
    },

    handleUpdateHistory(e) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        e.preventDefault();
        this.$emit("ok");
        this.$message.loading("Please wait... !", 3);
        this.formUpdate.validateFields((err, values) => {
          if (!err) {
            let sf4cId = [];
            values.staff.forEach((elemnt) => {
              sf4cId.push(JSON.parse(elemnt).sf4c_id);
            });
            let params = { sf4cId };
            this.$store
              .dispatch("timesheet/updateHistory", params)
              .then((res) => {
                if (res && res.data) {
                  this.$message.success("Update Successfully");
                  this.visibleUpdateJob = false;
                  this.formUpdate.resetFields();
                }
              })
              .catch((error) => {
                this.$message.error(error);
              });
          }
        });
      }, 800);
    },
    handleCancel() {
      this.formUpdate.resetFields();
      this.visibleUpdateJob = false;

      this.isShowModalImport = false;
    },
    sendEmail() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("click");
        this.$store.dispatch("user/loadingRequest");
        const data = {
          location: this.dataFilters.location ? this.dataFilters.location : [],
          employee: this.dataFilters.employee ? this.dataFilters.employee : [],
          department: this.dataFilters.department ? [].concat(this.dataFilters.department) : [],
          reason_type: this.dataFilters.reason_type ? this.dataFilters.reason_type : [],
          action_abnormal_case: this.dataFilters.abnormal_case ? this.dataFilters.abnormal_case : false,
          employee_id: this.selectedRowKeys,
          except_employee: this.staffSelectedListExcept,
        };
        http
          .post(`/tms/timesheets/${this.dataFilters.payroll_period}/send-email`, data)
          .then(() => {
            this.$message.success("The email has been sent successfully!", 5);
          })
          .catch((err) => {
            this.$message.error(err.response.data.error, 5);
          })
          .finally(() => {
            this.$store.commit("user/RESET_LOADING");
          });
        this.visibleConfirm = false;
      }, 500);
    },

    calculateWorkingDayManual() {
      this.formCalculateTimeSheets.validateFields((errors, values) => {
        if (errors) return;

        const dateCalculate = moment(values.calculate_date).format("YYYY-MM-DD");

        this.timeout = setTimeout(() => {
          this.$emit("click");
          this.$store.dispatch("user/loadingRequest");
          const data = {
            employee_id: this.currentFilterEmployee,
          };
          http
            .put(`/tms/timesheets/calculate-working-day?date=${dateCalculate}`, data)
            .then(() => {
              this.$message.success("You will receive a notification email when the calculation is finished!", 5);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message, 5);
            })
            .finally(() => {
              this.$store.commit("user/RESET_LOADING");
            });
          this.visibleCalculateWorkingDay = false;
        }, 500);
      });
    },

    calculateWorkingDayManualAllEmp() {
      this.formCalculateTimeSheetsAll.validateFields((errors, values) => {
        if (errors) return;
        const dateCalculate = moment(values.calculate_date).format("YYYY-MM-DD");
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$emit("click");
          this.$store.dispatch("user/loadingRequest");
          http
            .put(`/tms/timesheets/calculate-working-day-all-employees?date=${dateCalculate}`)
            .then(() => {
              this.$message.success("You will receive a notification email when the calculation is finished!", 5);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message, 5);
            })
            .finally(() => {
              this.$store.commit("user/RESET_LOADING");
            });
          this.visibleCalculateWorkingDayAllEmp = false;
        }, 500);
      });
    },

    getTimesheetDetail(timesheetId) {
      http.get(`/tms/timesheets/${timesheetId}`).then((res) => {
        this.timesheetInfo = res.data.data;
      });
    },

    getTimesheetData() {
      const { pageSize, currentPage, sort, direction } = this.configPage;
      this.$store.dispatch("user/loadingRequest");
      const paramFilter = {
        location: this.dataFilters.location ? this.dataFilters.location : [],
        divisions: this.dataFilters.divisions ? this.dataFilters.divisions : [],
        departmentsFilter: this.dataFilters.departmentsFilter ? this.dataFilters.departmentsFilter : [],
        role: this.dataFilters.role ? this.dataFilters.role : [],
        employee: this.dataFilters.employee ? this.dataFilters.employee : [],
        size: pageSize,
        page: currentPage,
        sort,
        direction,
        actionAbnormalCase: this.dataFilters.abnormal_case ? this.dataFilters.abnormal_case : false,
        reason_type: this.dataFilters.reason_type ? this.dataFilters.reason_type : [],
        workScheduleTypes: this.dataFilters.workScheduleTypes ? this.dataFilters.workScheduleTypes : [],
      };
      const params = {
        timesheetId: this.dataFilters.payroll_period,
        paramFilter: convertObjectToParams(paramFilter),
      };
      this.$store
        .dispatch("timesheet/getAllUserTimesheet", params)
        .then((res) => {
          if (res && res.data) {
            let data = res.data.map((item) => {
              item.key = item.id;
              item.staff = item.name;
              item.employmentID = item.id;
              item.totalNumberOfViolations = item.violationWorkingTime.countDaysNotEnoughWorkingTime
              if (item.timesheets) {
                item.timesheets.forEach((element) => {
                  const { check_in_time, check_out_time, history } = element;
                  let key = moment(element.date_of_issue).format("YYYYMMDD");
                  item[key] = element;
                  element.check_in_format = formatDateToString(check_in_time, DATE_FORMAT_HM);
                  element.check_out_format = formatDateToString(check_out_time, DATE_FORMAT_HM);
                  if (history && history?.history?.length > 0) {
                    const historyList = history?.history;
                    const historyNewest = historyList?.[historyList.length - 1];
                    element.history_newest = historyNewest;
                    element.history_newest_change = `${historyNewest?.old_value ?? ""} -> ${historyNewest?.new_value ?? ""
                      } (${formatDateToString(historyNewest?.modified_date, DATE_FORMAT_HM)})`;
                    element.history_newest_editor = getInfoStaff(historyNewest?.modifier) ?? "";
                    element.history_newest_comment = historyNewest?.comments ?? "";
                    element.history_total = historyList.length ?? 0;
                  }
                });
              }
              return item;
            });
            this.configPage.totalElement = res.page.total_element;
            this.configPage.pageSize = res.page.size;
            this.configPage.currentPage = res.page.page;
            this.$set(this.$data, "dataSource", data);
            this.firstCreated = false;
          }
          sessionStorage.setItem(
            this.page,
            JSON.stringify({ payroll_period: this.dataFilters.payroll_period, ...paramFilter })
          );
        })
        .catch(() => {
          this.$message.error("Fail to get Timesheet Data", 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },

    getUserTimesheetDetail(employmentID) {
      const params = {
        employmentID: employmentID,
        timesheetId: this.dataFilters.payroll_period,
      };
      this.$store.dispatch("user/loadingRequest");
      const actionDispatch =
        this.requestType === REQUEST_TYPE_HOUR ? "timesheet/getUserTimesheetFlexible" : "timesheet/getUserTimesheet";
      this.$store
        .dispatch(actionDispatch, params)
        .catch(() => {
          this.$message.error("Fail to get User Timesheet Data", 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
      this.$store.dispatch("timesheet/getCalculationWorkingEmployee", params).catch(() => {
        this.$message.error("Fail to get User Working Data", 5);
      });
      sessionStorage.setItem(
        this.page,
        JSON.stringify({
          employmentID: employmentID,
          payroll_period: this.dataFilters.payroll_period,
        })
      );
    },

    onShowDrawerTimesheetDetail(record) {
      this.showDrawer = true;
      this.drawerKey = "detail";
      this.titleDrawer = "Timesheet Detail";
      this.getUserTimesheetDetail(record.employmentID);
    },

    onShowDrawerNote() {
      this.showDrawer = true;
      this.drawerKey = "note";
      this.titleDrawer = "Note";
    },

    onCloseDrawer() {
      this.showDrawer = false;
      this.drawerKey = undefined;
      this.titleDrawer = "";
    },

    onShowDrawerComment() {
      this.showDrawer = true;
      this.drawerKey = "comment";
      this.titleDrawer = "All comment";
    },

    onshowModal() {
      this.visibleUpdateJob = true;
    },

    onChangeConfigPage(config) {
      this.configPage.pageSize = config.pageSize;
      this.configPage.currentPage = config.currentPage;
      this.configPage.direction = config.direction;
      this.getTimesheetData();
    },
    getStatus() {
      return getStatusTimeSheet(this.timesheetInfo.status);
    },

    sendRequestReviewTimesheet() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("click");
        const data = { status: this.statusTimesheet.pendingApproval };
        http
          .put(`/tms/timesheets/${this.timesheetInfo.timesheet_id}/request-review`, data)
          .then(() => {
            this.getTimesheetDetail(this.timesheetInfo.timesheet_id);
            this.getTimesheetData();
          })
          .catch((err) => {
            this.$message.error(err.response.data.error, 5);
          });
      }, 500);
    },

    sendReviewTimesheet(status, content) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("click");
        const data = { status };
        if (content) {
          data.content = content;
        }
        http
          .put(`/tms/timesheets/${this.timesheetInfo.timesheet_id}/review`, data)
          .then(() => {
            this.getTimesheetDetail(this.timesheetInfo.timesheet_id);
            this.getTimesheetData();
          })
          .catch((err) => {
            this.$message.error(err.response.data.error, 5);
          });
        this.closeModal();
      }, 500);
    },

    sendRequestRejectTimesheet() {
      if (!this.commentReject) {
        this.isValidComment = false;
        return;
      }
      this.sendReviewTimesheet(statusTimesheet.reject, this.commentReject);
    },

    validRequired(value) {
      return !value ? false : true;
    },

    myFunction() {
      document.body.style.position = "fixed";
    },

    closeModal() {
      this.visibleModal = false;
      this.commentReject = "";
      this.isValidComment = true;
    },

    handleChangeTab(key) {
      this.keyTab = key;
      if (key === "detail") {
        this.page = "TimesheetUser";
        this.dataFilters = { ...this.dataFilters, ...JSON.parse(sessionStorage.getItem(this.page)) };
      } else {
        this.page = "Timesheet";
        this.dataFilters = { ...this.dataFilters, ...JSON.parse(sessionStorage.getItem(this.page)) };
      }
    },

    checkSendRequestReview() {
      return (
        (this.timesheetInfo.status === statusTimesheet.draft ||
          this.timesheetInfo.status === statusTimesheet.pendingUpdate) &&
        moment(this.timesheetInfo.to_date) < moment()
      );
    },
    onshowModalImport() {
      this.isShowModalImport = true
    },
    async onImport(values, onSuccess) {
      try {
        this.fetching = true;
        const res = await this.$store.dispatch("timesheet/importFile", values);
        const { status } = res;
        handleMessagesAPI(res?.headers);
        if (status === 200) {
          this.$message.success("Timesheet is imported successfully!", 5);
          onSuccess()
          this.handleCancel();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.fetching = false;
      }
    },
    async downloadTemplate() {
      this.loadingDownload = true;
      try {
        const res = await this.$store.dispatch("timesheet/downloadTemplate");
        handleMessagesAPI(res?.headers);
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        setTimeout(() => {
          this.loadingDownload = false;
        }, 500);
      }
    },
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
};
